import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import SpaceViewer from "./SpaceViewer";
import MezzanineFloorViewer from './MezzanineFloorViewer'; 
import SecondFloorViewer from './SecondFloorViewer'; 
import ThirdFloorViewer from './ThirdFloorViewer';
import LLR from "./LRR";
import MFloorViewer from "./MfloorZoom";


const App = () => {
  return (
    <BrowserRouter>
      <Routes>
     
        <Route path="/" element={<SpaceViewer />} />
        <Route path="/first-floor" element={<SpaceViewer />} />
        <Route path="/m-floor" element={<MezzanineFloorViewer />} />
        <Route path="/second-floor" element={<SecondFloorViewer />} />
        <Route path="/third-floor" element={<ThirdFloorViewer />} />
        <Route path="/lrr" element={<LLR />} />
        <Route path="/mfc" element={<MFloorViewer />} />

      


      </Routes>
    </BrowserRouter>
  );
};

export default App;